import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPackageEdit"><Path d="M3 21V3H8V10H16V3H21V11.6674C19.6206 11.1667 18.0152 11.4694 16.909 12.5756L12.5 16.9846V21H3Z" fill="currentColor"/><Path d="M14.5 3H9.5V8.5H14.5V3Z" fill="currentColor"/><Path d="M21.3637 13.6363C20.4264 12.699 18.9069 12.699 17.9697 13.6363L14 17.6059V20.9999H17.394L21.3637 17.0303C22.3009 16.093 22.3009 14.5735 21.3637 13.6363Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageEdit;
